import { render, staticRenderFns } from "./ResellerContact.vue?vue&type=template&id=cbe627ce&scoped=true&"
import script from "./ResellerContact.vue?vue&type=script&lang=js&"
export * from "./ResellerContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe627ce",
  null
  
)

export default component.exports